module.exports = __webpack_public_path__ + "img/create-treatment-button-mobile-en.50b1331f.jpg";